import { getConfig } from "../init";
import { LocationItem } from "../models/locationItem";
import { PicklistItem } from "../models/picklistItem";

class PicklistServiceController {
    async getLocations(): Promise<LocationItem[]> {
        const customerId = getConfig().customerId;

        const functionsUrl = getConfig().functionsUrl;

        const response = await fetch(`${functionsUrl}/getLocations?customerId=${customerId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        });

        return response.json();
    }

    async get(picklist: string, locale: string): Promise<PicklistItem[]> {
        const customerId = getConfig().customerId;

        const functionsUrl = getConfig().functionsUrl;

        const response = await fetch(`${functionsUrl}/getPicklist?customerId=${customerId}&picklist=${picklist}&locale=${locale}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        });

        return response.json();
    }
    async getMultiple(picklistIds: string[], locale: string): Promise<{ [key: string]: PicklistItem[] }> {
        const customerId = getConfig().customerId;

        const functionsUrl = getConfig().functionsUrl;

        const response = await fetch(`${functionsUrl}/getPicklists`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                {
                    customerId: customerId,
                    picklist: picklistIds,
                    locale: locale
                })
        });

        return response.json();
    }
    async getValue(picklist: string, locale: string, id: string): Promise<PicklistItem[]> {
        const customerId = getConfig().customerId;

        const functionsUrl = getConfig().functionsUrl;

        const response = await fetch(`${functionsUrl}/getPicklistValue?customerId=${customerId}&picklist=${picklist}&locale=${locale}&value=${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        });

        return response.json();
    }

    getAllLocales(): { key: string, value: string }[] {
        // TODO: Use library to get all locales
        return [{ key: 'en_US', value: 'English' }, { key: 'de_DE', value: 'German' }]
    }
}

export const PicklistService = new PicklistServiceController();